const feedbackCard = {
  title: 'משוב',
  by: 'מאת:',
  phone: 'טלפון:',
  via: 'דרך',
  notes: 'הערות',
  submit: 'הוסף משוב',
  source: {
    CrewLink: 'CrewLink',
    QR: 'QR',
    TripCard: 'כרטיס נסיעה',
  },
};

export default feedbackCard;
